import React from "react";
import styled from "styled-components";
import useGatsbyImage from "@sb-konzept/gatsby-source-storyblok/hooks/useGatsbyImage";
import { StoryblokComponent } from "@sb-konzept/gatsby-source-storyblok";
import Image from "gatsby-image";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/styles";
// import { usePageContext } from "components/PageContext";

// import Navbar from "../../components/DojoNavbar";

const Background = styled.div`
  > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
Box.Background = Background;

export default props => {
  const {
    content: {
      header,
      headerBanner,
      headerBannerAltText,
      title,
      subtitle,
      slider
    }
  } = props;
  const theme = useTheme();

  // const context = usePageContext();

  // console.log("SITEINFO", header, slider);

  return (
    <Box>
      {!!(header && header.length) ? (
        <StoryblokComponent content={header[0]} />
      ) : !!(slider && slider.length) && slider[0]?.slides[0]?.body?.length ? (
        <StoryblokComponent content={slider[0]} />
      ) : (
        // {/* DEPRECATED: old, static header banner site info */}
        <Box
          minHeight="360px"
          maxHeight="500px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          position="relative"
          textAlign="center"
        >
          <Box.Background>
            {headerBanner.localFile &&
              (headerBanner.localFile.childImageSharp ? (
                <Image
                  style={{ position: false }}
                  fluid={headerBanner.localFile.childImageSharp.fluid}
                  alt={headerBannerAltText || "image"}
                />
              ) : (
                <img
                  src={headerBanner.localFile.publicURL}
                  alt={headerBannerAltText || "image"}
                />
              ))}
          </Box.Background>

          <Box position="relative" mx={2}>
            {title.map(content => (
              <StoryblokComponent
                key={content._uid || content.id}
                content={content}
              />
            ))}

            <Typography variant="subtitle2" color="textSecondary">
              {subtitle}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};
